import { render, staticRenderFns } from "./JdsMonitorProvider.vue?vue&type=template&id=a21d7b8a&scoped=true&"
import script from "./JdsMonitorProvider.vue?vue&type=script&lang=ts&"
export * from "./JdsMonitorProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21d7b8a",
  null
  
)

export default component.exports